'use strict';

// var scrollAnimate = require('base/components/scrollAnimate');
var scrollAnimate = require('org/components/scrollAnimate');

/**
 * Display error messages and highlight form fields with errors.
 * @param {string} parentSelector - the form which contains the fields
 * @param {Object} fieldErrors - the fields with errors
 */
function loadFormErrors(parentSelector, fieldErrors) { // eslint-disable-line
    var $firstInvalidField = $();

    // Display error messages and highlight form fields with errors.
    $.each(fieldErrors, function (attr) {
        var $field = $('*[name=' + attr + ']', parentSelector);

        $field
            .addClass('is-invalid')
            .attr('aria-invalid', 'true')
            .siblings('.invalid-feedback')
            .html(fieldErrors[attr]);

        if (!$firstInvalidField.length) {
            $firstInvalidField = $field;
        }

        if ($field.hasClass('shippingPhoneNumber')) {
            $field.val('');
        }
    });

    // Animate to top of form that has errors
    var $formModal = $(parentSelector).parents('.modal');
    if ($formModal.length > 0) {
        var spacing = 100;
        var position = ($(parentSelector).find('.is-invalid').first().offset().top + $formModal.scrollTop()) - spacing;

        $(parentSelector).parents('.modal').animate({
            scrollTop: position
        }, 500);
    } else {
        scrollAnimate($(parentSelector));
    }

    if ($firstInvalidField.length) {
        $firstInvalidField.focus();
    }
}

/**
 * Clear the form errors.
 * @param {string} parentSelector - the parent form selector.
 */
function clearPreviousErrors(parentSelector) {
    $(parentSelector).find('.form-control.is-invalid').removeClass('is-invalid').removeAttr('aria-invalid');
    $(parentSelector).find('.invalid-feedback').empty();
    $('.error-message').hide();
}

module.exports = {
    loadFormErrors: loadFormErrors,
    clearPreviousErrors: clearPreviousErrors
};
